<template>
  <div class="col">
    <appResolutionHeader
      :majority-name="findMajorityData(event.majority_id).name"
      :vote-order="voteOrder"
      :resolution="resolution"
      :parent-resolution-name="parentResolution.name"
      :parent-resolution-number="parentResolution.resolution_number"
    />
  </div>
</template>

<script>
import resolutionHeader from "./resolutionSummary/header";

export default {
  components: {
    appResolutionHeader: resolutionHeader,
  },
  props: {
    event: {
      type: Object,
      require: true,
    },
    voteOrder: {
      type: Number,
      require: true,
    },
    resolution: {
      type: Object,
      require: true,
    },
    parentResolution: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>
